import posthog from '@/lib/posthog';
import { getEnv } from '@/lib/env';
import titleize from 'titleize';

export const PAGE_NAMES = {
  '/': 'Dashboard',
  '/login': 'Login',
  '/login-app': 'Login (App)',
  '/signup': 'Sign Up',
  '/reset-password': 'Reset Password',
  '/setup-two-fa': 'Setup Two-Factor',
  '/calendar': 'Calendar',
  '/monitoring': 'Monitoring',
  '/api-keys': 'API Keys',
  '/integrations': 'Integrations',
  '/contact-us': 'Contact Us',
  '/terms-of-use': 'Terms of Use',
  '/privacy-policy': 'Privacy Policy',

  // Contacts
  '/contacts': 'Contacts',
  '/contacts/new': 'New Contact',
  '/contacts/new-tpm': 'New Contact (TPM)',
  '/contacts/new-funeral-homes': 'New Contact (Funeral Homes)',
  '/contacts/email': 'Contacts Email',
  '/contacts/sms': 'Contacts SMS',
  '/contacts/transfer': 'Contacts Transfer',
  '/contacts/merge': 'Contacts Merge',
  '/contacts/phone-burner': 'Phone Burner',
  '/contacts/advanced-search': 'Advanced Search',
  '/contacts/advanced-download': 'Advanced Download',
  '/contacts/email-history': 'Email History',
  '/contacts/file-history': 'File History',
  '/contacts/transfer-history': 'Transfer History',
  '/contacts/workflow-history': 'Workflow History',
  '/contacts/import': 'Contacts Import',
  '/contacts/import/platform': 'Contacts Import (Platform)',
  '/contacts/store': 'Contacts Store',
  '/contacts/[id]': 'Contact Detail',
  '/contacts/[id]/csg': 'Contact CSG',
  '/contacts/[id]/firelight': 'Contact Firelight',
  '/contacts/[id]/policies': 'Contact Policies',
  '/contacts/[id]/policies/[policy_id]': 'Contact Policy Detail',

  // Billing
  '/billing': 'Billing',
  '/billing/orders': 'Billing Orders',
  '/billing/plan': 'Billing Plan',
  '/billing/addons': 'Billing Add-ons',
  '/billing/review': 'Billing Review',
  '/billing/update': 'Billing Update',

  // Reports
  '/reports': 'Reports',
  '/reports/list': 'Reports List',
  '/reports/status': 'Status Report',
  '/reports/activity-tracking': 'Activity Tracking Report',
  '/reports/data-capture': 'Data Capture Report',
  '/reports/data-capture-activity-tracking': 'Data Capture Activity Report',
  '/reports/distributed-names': 'Distributed Names Report',
  '/reports/lead-activity': 'Lead Activity Report',
  '/reports/status-enrolled-to-client': 'Status Enrolled-to-Client Report',
  '/reports/calendar-event': 'Calendar Event Report',
  '/reports/marketing-activity': 'Marketing Activity Report',
  '/reports/sms-usage': 'SMS Usage Report',
  '/reports/wf-engagement': 'Workflow Engagement Report',
  '/reports/certification': 'Certification Report',

  // Wallets
  '/wallets': 'Wallets',
  '/wallets/receipt': 'Wallet Receipt',

  // Account
  '/account/profile': 'Account Profile',
  '/account/profile/external_accounts': 'External Accounts',

  // Dialer
  '/dialer': 'Dialer',
  '/dialer/logs': 'Dialer Logs',
  '/dialer/subscriptions': 'Dialer Subscriptions',
  '/dialer/setup/options': 'Dialer Setup',
  '/dialer/setup/self': 'Dialer Setup (Self)',
  '/dialer/setup/company': 'Dialer Setup (Company)',

  // SMS
  '/sms/messages': 'SMS Messages',
  '/sms/conversations': 'SMS Conversations',
  '/sms/subscriptions': 'SMS Subscriptions',
  '/sms/setup/options': 'SMS Setup',
  '/sms/setup/self': 'SMS Setup (Self)',
  '/sms/setup/company': 'SMS Setup (Company)',

  '/workflows': 'Workflows',
  '/training': 'Training'
};

const UNTRACKED_ROUTES = ['/[subdomain]'];

const isEnabled = () =>
  typeof window !== 'undefined' && process.env.NODE_ENV !== 'development' && !!getEnv('NEXT_PUBLIC_POSTHOG_KEY');

export const getPageName = pathname => {
  if (!pathname) return 'Unknown';
  if (PAGE_NAMES[pathname]) return PAGE_NAMES[pathname];

  const segments = pathname.split('/').filter(Boolean);
  const lastStatic = [...segments].reverse().find(seg => !seg.startsWith('['));
  if (!lastStatic) return 'Dashboard';
  return titleize(lastStatic.replace(/[-_]/g, ' '));
};

export const trackPageView = pathname => {
  if (!isEnabled()) return;
  if (UNTRACKED_ROUTES.includes(pathname)) return;
  posthog.capture('page_viewed', {
    page_name: getPageName(pathname),
    route_pattern: pathname
  });
};

export const trackLanding = pathname => {
  if (!isEnabled()) return;
  posthog.capture('post_login_landing', {
    page_name: getPageName(pathname),
    route_pattern: pathname
  });
};

export const trackHelpWidgetOpened = pathname => {
  if (!isEnabled()) return;
  posthog.capture('freshdesk_widget_opened', {
    page_name: getPageName(pathname),
    route_pattern: pathname
  });
};
